//请自行添加语言资源
const assign = {
  assignCode:'堆场编码',
  assignName:'堆场名称',
  proviceName: '省份',
  cityName: '城市',
  addr:'详细地址',
  assignTypeCode:'堆场类型编码',
  assignTypeName:'堆场类型名称',
  contact:'联系人',
  tel:'联系电话',
  email: '联系邮箱',
  createTime:'创建时间',
  creator:'创建者',
  updateTime:'更新时间',
  updater:'更新者',
  msg:{
    recycleBoxNo: '请输入周转箱号起始数字',
    recycleBoxNoBegin: '请输入周转箱号结束数字',
    recycleBoxNoEnd: '请输入周转箱号',
    warehouseCode: '请选择仓库'
  }
};
export default assign



// WEBPACK FOOTER //
// ./src/page/order/assign/lang/assign.zh.js